<template>
    <a-card title="Troca de Senha" style="max-width: 500px; margin: auto;">
        <a-form
            :model="form"
            :rules="rules"
            ref="formRef"
            layout="vertical"
            @finish="handleSubmit"
        >
            <a-form-item label="Nova Senha" name="newPassword">
                <a-input-password v-model:value="form.newPassword" placeholder="Digite a nova senha" autocomplete="new-password" />
            </a-form-item>

            <a-form-item label="Confirmar Nova Senha" name="confirmPassword">
                <a-input-password
                    v-model:value="form.confirmPassword"
                    placeholder="Confirme a nova senha"
                    @input="checkPasswords"
                    autocomplete="new-password"
                />
                <p v-if="passwordMismatch" style="color: red; margin-top: 8px;">
                    As senhas não coincidem.
                </p>
            </a-form-item>

            <a-form-item>
                <a-button type="primary" html-type="submit" :disabled="passwordMismatch">
                    Alterar Senha
                </a-button>
            </a-form-item>
        </a-form>
    </a-card>
</template>

<script setup>
import { ref, reactive } from 'vue';
import { message } from 'ant-design-vue';
import { notification } from 'ant-design-vue';
import { openNotification } from '../../../../utils/utilities';
const formRef = ref(null);

const form = reactive({
    newPassword: '',
    confirmPassword: ''
});

const passwordMismatch = ref(false);

const rules = {
    newPassword: [{ required: true, message: 'Por favor, insira a nova senha.' }],
    confirmPassword: [{ required: true, message: 'Por favor, confirme a nova senha.' }]
};

const checkPasswords = () => {
    passwordMismatch.value = form.newPassword !== form.confirmPassword;
};

const handleSubmit = async () => {
    if (passwordMismatch.value) {
        message.error('As senhas não coincidem.');
        return;
    }

    try {
        const response =  await window.axios.post('api/configurations/users/change-password', form)
        openNotification('success', response.data.message)
        window.location.reload()
    } catch (error) {
        if (error.response && error.response.data) {
            const { message, errors } = error.response.data;
            if (errors) {
                Object.entries(errors).forEach(([field, messages]) => {
                    messages.forEach(msg => openNotification('error', `${msg}`));
                });
                return
            }
            openNotification('error', message || 'Erro ao alterar a senha.');
        } else {
            openNotification('error', 'Erro inesperado. Tente novamente mais tarde.');
        }
    }
};
</script>

<style scoped>
a-card {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

a-button {
    width: 100%;
}
</style>
